<template>
  <div class="mentor-process-container">
    <div class="mentor-process-title">我的导师辅导</div>
    <template v-if="processData">
      <Process
        v-if="processData"
        :process="processData"
        :platform="platform"
        style="margin-bottom: 12px"
        @refresh="fetchProcessData"
      />
      <OrderDetail
        v-if="mentorOrderDetail"
        :detail="mentorOrderDetail"
        style="margin-bottom: 12px"
      />
      <Conversation
        v-if="processData"
        :process="processData"
        :platform="platform"
        style="margin-bottom: 12px"
        @refresh="fetchProcessData"
      />
      <Feedback
        v-if="platform === 'user' && processData"
        :process="processData"
        style="margin-bottom: 50px"
        @refresh="fetchProcessData"
      />
    </template>
    <template v-else>
      <!-- <div class="empty-content">暂无导师服务</div>  -->
    </template>
  </div>
</template>
<script>
import api from "@/api";
import Process from "./Process.vue";
import OrderDetail from "./OrderDetail.vue";
import Conversation from "./Conversation.vue";
import Feedback from "./Feedback.vue";

export default {
  name: "MentorProcess",
  data() {
    return {
      mentorOrderDetail: null,
      processData: null,
    };
  },
  components: {
    OrderDetail,
    Process,
    Conversation,
    Feedback,
  },
  computed: {
    platform() {
      return window.location.href.includes("mentor") ? "mentor" : "user";
    },
  },
  methods: {
    async fetchMentorOrderDetail() {
      try {
        const token = this.$route.params.token;
        const res = await api.mentorOrders.getCvTokenMentorOrders(token);
        if (res.code === 1000) {
          this.mentorOrderDetail = res.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchProcessData() {
      try {
        const token = this.$route.params.token;
        const res = await api.cvsEditor.mentorComments(token);
        if (res.code === 1000) {
          this.processData = res.data;
        } else if (res.code === 80150) {
          this.processData = {
            task: {
              state: 'end'
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    if (!this.$store.state.editor.cvDetail.basic_info.mentor_id) return;
    this.fetchMentorOrderDetail();
    this.fetchProcessData();
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.mentor-process-container {
  padding: 0 24px;
  width: 100%;
  height: 100%;
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  .mentor-process-title {
    font-size: 16px;
    font-weight: 600;
    color: $text-color;
    margin-bottom: 24px;
  }
  .block-item-container {
    padding: 24px 18px;
    background-color: $form-bg-color;
    border-radius: 8px;
    .block-item-title-content,
    :deep(.block-item-title-content) {
      margin-bottom: 24px;
      .title {
        font-size: 16px;
        font-weight: 600;
        color: $text-color;
      }
    }
  }
}
.empty-content {
  font-size: 16px;
  color: $text-color;
  text-align: center;
  margin-top: 24px;
}
</style>
